// Root Reducer
import authReducer from './slices/authSlice';
import pmShriConstantsReducer from './slices/pmShriConstantsSlice';

// Export as object (not combineReducers) so store can spread and add RTK Query
const rootReducer = {
  auth: authReducer,
  pmShriConstants: pmShriConstantsReducer,
  // Add other reducers here
};

export default rootReducer;
